module.exports = __webpack_public_path__ + "static/media/loading.53230f81.svg";